import { render, staticRenderFns } from "./RewardsCardCollect.vue?vue&type=template&id=90e8c2cc&scoped=true&"
import script from "./RewardsCardCollect.vue?vue&type=script&lang=js&"
export * from "./RewardsCardCollect.vue?vue&type=script&lang=js&"
import style0 from "./RewardsCardCollect.vue?vue&type=style&index=0&id=90e8c2cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e8c2cc",
  null
  
)

export default component.exports